// import React from "react";
// import both from "../img/both.png";
// import { useNavigate, useNavigation } from "react-router-dom";

// export default function Protect() {
//   const navigation = useNavigate();

//   return (
//     <div className=" max-w-7xl lg:mt-24  px-4 sm:px-6 ">
//       <div style={{paddingRight:"40px",paddingLeft:"40px" ,paddingBottom:0,paddingTop:0}} className="bg-[#2FB57C]  rounded-lg justify-between  sm:p-6  lg:flex  flex-row items-center ">
//         {/* Image */}
//         <div className="">
//           <img style={{width:"100%",maxWidth:"470px"}}
//             src={both}
//             alt="Graduating kids"
//             className=" sm:w-56 lg:block hidden md:w-64   object-contain -mt-5 md:-mt-20 lg:-mt-24"
//           />
//         </div>

//         {/* Text & Button */}
//         <div className=" md:w-1/2 text-center md:text-left text-white">
//           <h2 style={{fontFamily:"Fredoka"}} className="lg:text-[44px] text-[24px] sm:text-xl lg:leading-[45px] md:text-2xl lg:text-[44px] font-semibold mb-4">
//             Protect your children. Protect your staff. Stay compliant.
//           </h2>
//           <button onClick={(()=>{navigation("/getCertified")})}  style={{fontFamily:"Poppins"}} className=" mb-4 bg-[#F0AA00] w-[250px] text-white font-semibold py-3 px-8 rounded-full hover:bg-yellow-600 transition mt-6 w-full sm:w-auto">
//             Get Certified Now →
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

import React from "react";
import both from "../img/men.png";
import { useNavigate } from "react-router-dom";

export default function Protect(props) {
  const navigation = useNavigate();

  return (
    <div className="max-w-7xl container  mx-auto px-4 sm:px-6 py-12 md:py-16 lg:pt-24">
      <div style={{paddingRight:"40px",paddingLeft:"40px" ,paddingBottom:0,paddingTop:0}} className="bg-[#2FB57C] rounded-lg flex flex-col lg:flex-row items-center justify-between px-6 sm:px-8 md:px-10 py-8 md:py-10 lg:py-12 gap-8">
        {/* Image - Hidden on mobile, visible on lg+ */}
              <div className="">
        <img style={{width:"100%",maxWidth:"470px"}}
           src={props.img ? props.img : both}
           alt="Graduating kids"
            className=" sm:w-56 lg:block hidden md:w-64   object-contain -mt-5 md:-mt-20 lg:-mt-24"
          />
        </div>

        {/* Text & Button - Always visible */}
        <div className="w-full lg:w-1/2 text-center lg:text-left text-white">
          <h2 
            style={{ fontFamily: "Fredoka" }}
            className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-4 md:mb-6 leading-tight"
          >
            Protect your children. Protect your staff. Stay compliant.
          </h2>
          <button 
            onClick={() => navigation("/getCertified")}
            style={{ fontFamily: "Poppins" }}
            className="bg-[#F0AA00] hover:bg-yellow-600 text-white font-semibold py-3 px-8 rounded-full transition duration-300 w-full sm:w-[250px]"
          >
            Get Certified Now →
          </button>
        </div>

        {/* Image - Visible on mobile only (below text) */}
        <div className="block lg:hidden w-full mt-6">
          <img
            src={both}
            alt="Graduating kids"
            className="w-full max-w-[280px] mx-auto object-contain"
          />
        </div>
      </div>
    </div>
  );
}